/* Copyright © 2026 Xerox Corporation. All Rights Reserved. Copyright protection claimed includes all forms and matters of copyrightable material and information now allowed by statutory or judicial law or hereinafter granted, including without limitation, material generated from the software programs which are displayed on the screen such as icons, screen display looks, etc. */

import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { XrxControlBaseComponent } from './xrx-control-base.component';
import { OptionListOptions } from '../../services/workflow.service';

@Component({
  selector: 'xrx-select-conversion',
  templateUrl: './xrx-select-conversion.component.html',
  styleUrls: ['./xrx-select-conversion.component.less'],
  providers: [
    {
      provide: XrxControlBaseComponent,
      useExisting: XrxSelectConversionComponent,
    },
  ],
  standalone: false,
})
export class XrxSelectConversionComponent
  extends XrxControlBaseComponent
  implements OnInit
{
  @Input() id: string;
  @Input() property: string;
  @Input() localize: string;
  @Input() type: string;
  @Input() error: string;
  @Input() orderby: string;
  @Input() dir = 'asc';
  @Input() required: boolean;
  @Input() description: string;

  @Input() list: OptionListOptions[];
  @Input() list2: OptionListOptions[];
  @Input() label: string;
  @Input() label2: string;
  @Input() inlineLabel: string;
  @Input() inlineLabel2: string;
  @Input() selectedItem: any;
  @Input() selectedItem2: any;
  @Output() change = new EventEmitter<any>();
  @Output() change2 = new EventEmitter<any>();
  @Output() validation = new EventEmitter<boolean>();
  @Output() selectedItemChange = new EventEmitter<OptionListOptions>();
  @Output() selectedItem2Change = new EventEmitter<OptionListOptions>();
  @Output() selectedValueChange = new EventEmitter<OptionListOptions>();

  toLanguageTouched = false;

  ngOnInit() {
    this.doValidate(this.selectedItem, this.selectedItem2);
  }

  /**
   * called by parent component
   */
  validate() {
    this.toLanguageTouched = true;
    this.doValidate(this.selectedItem, this.selectedItem2);
  }

  doValidate(selectedItem: any, selectedItem2: any) {
    this.validation.emit(
      selectedItem?.value !== selectedItem2?.value &&
        selectedItem?.value &&
        selectedItem2.value
        ? true
        : false,
    );
    this.toLanguageTouched = true;
  }
}
